// extracted by mini-css-extract-plugin
var _1 = "SettingSectionButtons-moduleSettingSectionButtons__Mambo";
export { _1 as "SettingSectionButtons" }
